import { Button } from '../Button/Button.tsx';
import type { Pagination, TableLabels } from './table-types.ts';
import styles from './DataTable.module.css';

export const PaginationBar = ({ pagination, labels }: { pagination: Pagination; labels: TableLabels }) => {
  const from = pagination.total === 0 ? 0 : (pagination.page - 1) * pagination.pageSize + 1;
  const to = Math.min(pagination.page * pagination.pageSize, pagination.total);
  const lastPage = Math.max(1, Math.ceil(pagination.total / pagination.pageSize));
  return (
    <nav className={styles['pagination']} aria-label="Pagination">
      <span>{labels.range(from, to, pagination.total)}</span>
      <span className={styles['pageButtons']}>
        <Button
          variant="outline"
          size="sm"
          disabled={pagination.page <= 1}
          onClick={() => {
            pagination.onPageChange(pagination.page - 1);
          }}
        >
          {labels.previous}
        </Button>
        <Button
          variant="outline"
          size="sm"
          disabled={pagination.page >= lastPage}
          onClick={() => {
            pagination.onPageChange(pagination.page + 1);
          }}
        >
          {labels.next}
        </Button>
      </span>
    </nav>
  );
};
